import React from 'react'
import { Link } from 'react-router-dom'
import '../styles/Footer.css'
export default function Footer() {
  return (
    <footer>
        Vocabo © {new Date().getFullYear()}
    </footer>
  )
}
